import { Star } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const TESTIMONIALS = [
  { img: "https://images.unsplash.com/photo-1753351052363-53ce102830eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", name: "Lucía Ramírez", biz: "Cafetería en Sevilla", quote: "Pasé de publicar cuando me acordaba a tener contenido todas las semanas. Las reservas de brunch se duplicaron.", result: "+110% reservas" },
  { img: "https://images.unsplash.com/photo-1765648580890-732fa6d769c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", name: "Valentina Ortiz", biz: "Tienda de bisutería online", quote: "Me hicieron la tienda y los anuncios. Por primera vez vendo a gente que no me conoce.", result: "62 pedidos el 1er mes" },
  { img: "https://images.unsplash.com/photo-1687293233211-6b0cc3beba70?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", name: "Andrea Molina", biz: "Consultora de nutrición", quote: "El asistente de WhatsApp responde mientras estoy en consulta. Ya no pierdo clientas por tardar.", result: "3x más consultas" },
];

export const Testimonials = () => (
  <section className="bg-[#F4A261]/10">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-wider text-[#E05A47]">Historias reales</p>
        <h2 className="mt-3 text-3xl font-bold tracking-tight text-[#1E1A17] sm:text-4xl">Emprendedoras como tú que ya venden más</h2>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <figure data-testid={`testimonial-${i}`} className="flex h-full flex-col rounded-2xl border border-[#E8E1D7] bg-white p-8">
              <div className="flex gap-0.5 text-[#F4A261]">{[...Array(5)].map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}</div>
              <blockquote className="mt-4 flex-1 font-display text-lg leading-snug text-[#1E1A17]">“{t.quote}”</blockquote>
              <span className="mt-6 inline-block w-fit rounded-full bg-[#2A9D8F]/10 px-3 py-1 text-xs font-semibold text-[#2A9D8F]">{t.result}</span>
              <figcaption className="mt-6 flex items-center gap-3">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover" />
                <div><div className="text-sm font-semibold">{t.name}</div><div className="text-xs text-[#6E655F]">{t.biz}</div></div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

const FAQS = [
  ["¿Necesito saber de tecnología o de marketing?", "No. Nosotras nos encargamos de todo y te lo explicamos con palabras sencillas. Tú solo nos cuentas de tu negocio."],
  ["¿La IA va a sonar como un robot?", "No. Usamos la IA para ir rápido, pero cada texto lo revisa una persona para que suene a ti y a tu marca."],
  ["¿Cuándo empiezo a ver resultados?", "Las primeras mejoras (perfil, publicaciones, respuestas automáticas) se notan en la primera semana. Las ventas suelen crecer a partir del primer mes."],
  ["¿Hay permanencia o contrato?", "No. Los paquetes son de pago único. Si quieres seguir con nosotras después, lo hablamos sin compromiso."],
  ["¿Trabajáis con negocios fuera de España?", "Sí, trabajamos en remoto con emprendedoras de toda España y Latinoamérica."],
];

export const Faq = () => (
  <section id="faq" className="mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 lg:grid-cols-12 lg:px-8 lg:py-28">
    <Reveal className="lg:col-span-4">
      <p className="text-xs font-semibold uppercase tracking-wider text-[#E05A47]">Preguntas frecuentes</p>
      <h2 className="mt-3 text-3xl font-bold tracking-tight text-[#1E1A17] sm:text-4xl">Resolvemos tus dudas</h2>
    </Reveal>
    <Accordion type="single" collapsible className="lg:col-span-8">
      {FAQS.map(([q, a], i) => (
        <AccordionItem key={q} value={`f${i}`} className="border-[#E8E1D7]">
          <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left text-base font-semibold hover:text-[#E05A47] hover:no-underline">{q}</AccordionTrigger>
          <AccordionContent className="pb-6 text-base text-[#6E655F]">{a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
